<template>
    <uw-content title="入库单">
        <template slot="suffix">
            <el-button type="primary" size="mini" @click="$refs.createEnter.Open()" >新建入库单</el-button>
        </template>
        <uw-table>
            <template slot="search">
                <ims-warehouse-select  v-model="search.warehouse_id" @onChange="TableSearch()" />
            </template>
            <template slot="button">
                <el-button type="primary" size="mini" @click="$refs.xTable.openExport()" >导出</el-button>
            </template>
            <template slot="data">
                <vxe-table
                    ref="xTable"
                    :data="table"
                    :loading="loading"
                    :export-config="{}"
                    :print-config="{}"
                    :seq-config="{startIndex: page.size * (page.current - 1)}"
                    height="100%">
                    <vxe-column width="80" title="状态">
                        <template #default="{ row }">
                            <el-tag effect="dark" size="mini" v-if="row.state">已入库</el-tag>
                            <el-tag effect="dark" size="mini" v-if="!row.state" type="danger">已作废</el-tag>
                        </template>
                    </vxe-column>
                    <vxe-column width="100" title="入库类型">
                        <template #default="{ row }">
                            <span v-if="row.model == 'init'">初始化入库</span>
                            <span v-if="row.model == 'other'">其它入库</span>
                            <span v-if="row.model == 'ims_product_order'">采购订单</span>
                            <span v-if="row.model == 'ims_product_apply'">产品申领</span>
                        </template>
                    </vxe-column>
                    <vxe-column min-width="120" field="number" title="入库单号"></vxe-column>
                    <vxe-column min-width="120" title="关联订单">
                        <template #default="{ row }">
                            <span class="el-span-primary" v-if="row.model == 'ims_warehouse_move'" @click="$refs.warehouseMoveDrawer.Open(row.model_id)">{{ row.model_number }}</span>
                            <span class="el-span-primary" v-else-if="row.model == 'ims_product_order'" @click="$refs.productOrderDrawer.Open(row.model_id)">{{ row.model_number }}</span>
                            <span class="el-span-primary" v-else-if="row.model == 'ims_product_back'" @click="$refs.productBackDrawer.Open(row.model_id)">{{ row.model_number }}</span>
                            <span class="el-span-primary" v-if="row.model == 'ims_product_apply'" @click="$refs.productApplyDrawer.Open(row.model_id)">{{ row.model_number }}</span>
                        </template>
                    </vxe-column>
                    <vxe-column width="140" field="created_at" title="入库时间"></vxe-column>
                    <vxe-column min-width="120" field="describe" title="备注"></vxe-column>
                    <vxe-column width="100" field="created_user.name" title="负责人"></vxe-column>
                </vxe-table>
            </template>
            <template slot="pager">
                <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
            </template>
        </uw-table>
        <ims-warehouse-document-create-enter ref="createEnter" @onChange="TableSearch" />
        <ims-order-drawer ref="productOrderDrawer" @onChange="TableSearch" />
        <ims-product-back-drawer ref="productBackDrawer" @onChange="TableSearch" />
        <ims-product-apply-drawer ref="productApplyDrawer" @onChange="TableSearch" />
    </uw-content>
</template>
<script>
export default {
    data () {
        return {
                        loading: false,
            table: [],
                        page: {
                total: 0,
                size: 50,
                current: 1,
            },
            search: {
                warehouse_id: null,
                number: null,
                action: 1
            },
                        order: {
                method: 'desc',
                column: 'id'
            },
        }
    },
    mounted () {
        this.TableSearch()
    },
    methods: {
                TableSearch() {
                        this.loading = true
            this.$http.post(
                '/9api/ims/warehouse-document/search',
                {
                    page: this.page,
                    search: this.search,
                    order: this.order,
                    append: ['created_user', 'model_number']
                }
            ).then(rps => {
                                this.page.total = rps.data.total
                this.table = rps.data.body
                                if (this.table.length == 0 && this.page.current != 1) {
                    this.page.current = 1
                    this.TableSearch()
                }
                                this.loading = false
            })
        }
    }
}
</script>